import { queryClient } from "../lib/query-client";
import { fetchProtocols, protocolQueryConfig, protocolQueryKeys } from "./protocol-data";

/**
 * Global route loader that prefetches data needed across all routes
 * This ensures that commonly used data is available immediately when navigating between routes
 */
export async function globalLoader() {
  // Execute all global data prefetching in parallel for better performance
  await Promise.all([
    // Prefetch protocol data from Contentful
    queryClient.prefetchQuery({
      queryKey: protocolQueryKeys.lists(),
      queryFn: fetchProtocols,
      ...protocolQueryConfig,
    }),
  ]);

  return null;
}
